export default {"src":"/_next/static/media/metamask.07f93cbb.svg","height":189,"width":212};